import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';
import { useTranslation } from 'react-i18next';
export function ImagePreview({ image }) {
    const { t } = useTranslation();
    if (!image) {
        return _jsx(_Fragment, { children: t('Solution image not found') });
    }
    return (_jsx(TransformWrapper, { children: _jsx(TransformComponent, { wrapperStyle: {
                height: 'calc(100vh - 190px)',
                justifyContent: 'center',
                display: 'flex',
                alignItems: 'center'
            }, children: _jsx("img", { src: image, alt: 'img', style: {
                    height: '100%',
                    maxHeight: 'calc(100vh - 150px)',
                    width: '100%'
                } }) }) }));
}
